export var OptionsMenuPosition = {
  right: 'right',
  left: 'left'
};
export var OptionsMenuDirection = {
  up: 'up',
  down: 'down'
};